import { Link } from '@hover/blueprint';
import React, { useEffect, useState } from 'react';

import { useRenderingContext } from 'src/modules/renderings/hooks';
import { FeatureFlag } from 'src/shared/constants';
import {
  TranslationNamespace,
  useClosure,
  useSplit,
  useTranslate,
} from 'src/shared/hooks';
import { Route } from 'src/shared/route';

import { BaseCTAButton } from './BaseCTAButton';

export const SHARED_CTA_LINK_TEST_ID = 'shared-view-cta-link';
export const SHARED_CTA_BUTTON_TEST_ID = 'shared-view-cta-button';

interface CtaOverrides {
  text: string;
  url: string;
}

const SharedViewCTA = () => {
  const t = useTranslate(TranslationNamespace.COMMON);

  const { orgId, partnerId, userId } = useRenderingContext();
  const { client: clientPromise, updateUserId } = useSplit();
  const updateSplitUserId = useClosure(updateUserId);
  const [ctaOverrides, setCtaOverrides] = useState<CtaOverrides>();
  useEffect(() => {
    if (userId) {
      updateSplitUserId(userId.toString());
    }
  }, [userId, updateSplitUserId]);
  useEffect(() => {
    if (ctaOverrides) {
      return;
    }
    void (async () => {
      const client = await clientPromise;
      const { config } =
        client?.getTreatmentWithConfig(
          FeatureFlag.Renderings.RENDERINGS_SHARE_CTA,
          {
            orgId,
            org_id: orgId,
            partnerId,
            partner_id: partnerId,
          } as SplitIO.Attributes,
        ) ?? {};
      if (config) {
        setCtaOverrides(JSON.parse(config) as CtaOverrides);
      }
    })();
  }, [clientPromise, orgId, ctaOverrides, partnerId]);

  return (
    <Link
      href={ctaOverrides?.url ?? Route.SIGN_UP.path}
      isMinimal
      testId={SHARED_CTA_LINK_TEST_ID}
      width="100%"
    >
      <BaseCTAButton fill="outline" testId={SHARED_CTA_BUTTON_TEST_ID}>
        {ctaOverrides?.text ?? t('signUp')}
      </BaseCTAButton>
    </Link>
  );
};

export { SharedViewCTA };
